import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { StyleSheet, View } from '@react-pdf/renderer';
import CardItemExteriorColor from './CardItemExteriorColor';
import CardItemImage from './CardItemImage';
import CardItemPricingInfo from './CardItemPricingInfo';
import CardItemTitle from './CardItemTitle';
import CategoryTitle from './CategoryTitle';
import EmptyCard from './EmptyCard';
import IncludedBadge from './IncludedBadge';
const styles = StyleSheet.create({
    container: {
        borderRadius: '3px',
        border: '1px solid #EAEAEA',
        height: '80px',
        marginBottom: '8px',
        flexDirection: 'row',
    },
});
const CardItem = ({ item, isVariant }) => (_jsxs(View, { style: { marginBottom: '8px' }, children: [_jsx(CategoryTitle, { categoryTitle: item.categoryTitle }), _jsx(View, { style: styles.container, children: item.noSelectedItemsLabel ? (_jsx(EmptyCard, { noSelectedItemsLabel: item.noSelectedItemsLabel })) : (_jsxs(View, { style: { flexDirection: 'row' }, children: [!item.isWarranty && (_jsxs(View, { style: { width: '90px' }, children: [_jsx(CardItemImage, { id: item.id, imageSrc: item.imageSrc }), _jsx(CardItemExteriorColor, { colorHexValue: item.colorHexValue })] })), _jsxs(View, { style: { padding: '8px', flexDirection: 'column', justifyContent: 'space-between' }, children: [_jsx(CardItemTitle, { title: item.title, termLabel: item.termLabel }), item.showIncludedBadge ? (_jsx(IncludedBadge, { isVariant: isVariant })) : (_jsx(CardItemPricingInfo, { priceText: item.priceText, paymentText: item.paymentText }))] })] })) })] }));
export default CardItem;
